module.exports = __webpack_public_path__ + "static/media/g.5ff59683.png";